export default __webpack_public_path__ + "static/media/piza.1ed89552.jpg";